module.exports = __webpack_public_path__ + "static/media/DSC00509-24_Small.a43d5781.jpg";